module.exports = __webpack_public_path__ + "static/img/github_image@3x.6196ce9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/3x/github_image@3x.png
// module id = zk6p
// module chunks = 1